module.exports = {"label":{"title":"Available Name Servers"},"header":{"name":"Name","location":"Location"}}